import script from "./StatusAI.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusAI.vue?vue&type=script&setup=true&lang=js"

import "./StatusAI.vue?vue&type=style&index=0&id=6ea94f5e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea94f5e"]])

export default __exports__